<template>
    <button
        @click="$emit('click')"
        class="w-24 h-24 rounded-6 trans-ease flex items-center justify-center"
        :class="[ active ? 'text-secondary hover:text-secondary focus:text-secondary' : ( highlight ? 'text-primary hover:text-primary-60 focus:text-primary-60' : 'text-primary-80 hover:text-primary focus:text-primary')]"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        highlight: Boolean,
    }
}
</script>
